import React from 'react'
import PropTypes from 'prop-types'

const ConversationIcon = (props) => {
  const { color = '#183560', classes = 'w-20' } = props
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7 4.8V11.1H5.853L5.322 11.631L4.8 12.153V4.8H14.7ZM15.6 3H3.9C3.405 3 3 3.405 3 3.9V16.5L6.6 12.9H15.6C16.095 12.9 16.5 12.495 16.5 12V3.9C16.5 3.405 16.095 3 15.6 3ZM20.1 6.6H18.3V14.7H6.6V16.5C6.6 16.995 7.005 17.4 7.5 17.4H17.4L21 21V7.5C21 7.005 20.595 6.6 20.1 6.6Z"
        fill={color}
      />
    </svg>
  )
}

ConversationIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(ConversationIcon)
